import { exchangeLabel, FILTER_TEXT, marketLetter } from "@/lib/labels";
import { exchangesOf, marketsOf } from "./derive";

/**
 * Значение фишки бирж свёрнутой строки (§115 п. 6): биржа со всеми рынками —
 * имя, с одним из нескольких — имя и буква («Binance S»); пустой отбор —
 * «ни одной». Биржи идут в порядке раздела «Биржа» (порядок рынков потока),
 * а не в порядке нажатий: выключить и включить биржу заново фишку не двигает.
 */
export function exchangesChipText(selected: readonly string[], known: readonly string[]): string {
  const parts: string[] = [];
  for (const exchange of exchangesOf(known)) {
    const own = marketsOf(known, exchange);
    const on = own.filter((market) => selected.includes(`${exchange}:${market}`));
    if (on.length === 0) {
      continue;
    }
    const name = exchangeLabel(exchange);
    parts.push(on.length === own.length ? name : `${name} ${on.map(marketLetter).join("")}`);
  }
  return parts.length > 0 ? parts.join(" · ") : FILTER_TEXT.noExchanges;
}
